(function () {
  let globalObserver = null;
  let observedElements = new Set();
  function hasUnderlineWrappers() {
    return document.querySelectorAll(".underline-wrapper").length > 0;
  }
  function fitTextToOneLine(textElement) {
    textElement.style.fontSize = "";
    const defaultFontSize = parseFloat(getComputedStyle(textElement).fontSize);
    const wrapper = textElement.parentElement;
    if (wrapper.scrollWidth <= wrapper.clientWidth) return;
    let lo = 8,
      hi = defaultFontSize;
    while (hi - lo > 0.5) {
      const mid = (lo + hi) / 2;
      textElement.style.fontSize = mid + "px";
      if (wrapper.scrollWidth <= wrapper.clientWidth) {
        lo = mid;
      } else {
        hi = mid;
      }
    }
    textElement.style.fontSize = lo + "px";
  }
  function getTextWidth(textElement) {
    for (const node of textElement.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        const range = document.createRange();
        range.selectNode(node);
        const width = range.getBoundingClientRect().width;
        if (width > 0) return width;
      }
    }
    return textElement.getBoundingClientRect().width;
  }
  function updateSvgPath(svgElement, pathElement, width) {
    const height = 6;
    const centerY = height / 2;
    const scaleX = width / 172;
    const scaledPath = `M${1.5 * scaleX} ${centerY}
        C${40.8352 * scaleX} ${centerY - 1},
         ${80.0597 * scaleX} ${centerY - 1.5},
         ${119.442 * scaleX} ${centerY - 1.5}
        C${135.703 * scaleX} ${centerY - 1.5},
         ${184.489 * scaleX} ${centerY - 1.5},
         ${168.227 * scaleX} ${centerY - 1.5}
        C${152.209 * scaleX} ${centerY - 1.5},
         ${136.191 * scaleX} ${centerY - 1.5},
         ${120.173 * scaleX} ${centerY - 1.5}
        C${99.6525 * scaleX} ${centerY - 1.5},
         ${79.1698 * scaleX} ${centerY - 1.65},
         ${58.6949 * scaleX} ${centerY - 0.05}
        C${57.3803 * scaleX} ${centerY + 0.05},
         ${45.8707 * scaleX} ${centerY + 0.7},
         ${46.6291 * scaleX} ${centerY + 1.5}`;
    svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
    pathElement.setAttribute("d", scaledPath);
  }
  function updateUnderlines() {
    document
      .querySelectorAll(".social-media__main-text")
      .forEach((textElement) => {
        const svgElement = textElement.querySelector(".underline-svg");
        const pathElement = textElement.querySelector(".line-path");
        if (!svgElement || !pathElement) return;
        fitTextToOneLine(textElement);
        const width = getTextWidth(textElement);
        if (width > 0) updateSvgPath(svgElement, pathElement, width);
        if (textElement.dataset.textAnimation === "true") {
          textElement.classList.add("is-ready");
        }
      });
  }
  function initIntersectionObserver() {
    const animatedElements = document.querySelectorAll(
      '.underline-wrapper[data-enable-animation="true"] .underline-svg'
    );
    if (animatedElements.length === 0) return;
    if (globalObserver) {
      subscribeNewElements();
      return;
    }
    globalObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const svgElement = entry.target;
        if (entry.isIntersecting && !svgElement.dataset.animated) {
          startUnderlineAnimation(svgElement);
          svgElement.dataset.animated = "true";
        }
      });
    });
    subscribeNewElements();
  }
  function subscribeNewElements() {
    document
      .querySelectorAll(
        '.underline-wrapper[data-enable-animation="true"] .underline-svg'
      )
      .forEach((element) => {
        if (!observedElements.has(element) && !element.dataset.observed) {
          element.style.strokeDasharray = "1800";
          element.style.strokeDashoffset = "1800";
          globalObserver.observe(element);
          observedElements.add(element);
          element.dataset.observed = "true";
        }
      });
  }
  function startUnderlineAnimation(svgElement) {
    if (
      svgElement
        .closest(".underline-wrapper")
        .getAttribute("data-enable-animation") !== "true"
    )
      return;
    if (svgElement.dataset.animating === "true") return;
    svgElement.dataset.animating = "true";
    svgElement.style.transition = "none";
    svgElement.style.strokeDashoffset = "1800";
    void svgElement.offsetWidth;
    svgElement.style.transition = "stroke-dashoffset 3s ease-in-out";
    svgElement.style.strokeDashoffset = "0";
    setTimeout(() => {
      svgElement.dataset.animating = "false";
    }, 3000);
  }
  function initStaticUnderlines() {
    document
      .querySelectorAll(
        '.underline-wrapper[data-enable-animation="false"] .underline-svg'
      )
      .forEach((svgElement) => {
        svgElement.style.strokeDasharray = "none";
        svgElement.style.strokeDashoffset = "0";
        svgElement.style.transition = "none";
        svgElement.dataset.animated = "true";
      });
  }
  function init() {
    if (!hasUnderlineWrappers()) return;
    setTimeout(() => {
      updateUnderlines();
      initStaticUnderlines();
      initIntersectionObserver();
    }, 300);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    setTimeout(init, 100);
  }
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (hasUnderlineWrappers()) {
        updateUnderlines();
        initStaticUnderlines();
      }
    }, 150);
  });
  if (typeof Shopify !== "undefined") {
    let shopifySectionTimeout;
    document.addEventListener("shopify:section:load", (event) => {
      const section = event.target;
      if (!section.querySelector(".social-media__main-text")) return;
      clearTimeout(shopifySectionTimeout);
      shopifySectionTimeout = setTimeout(() => {
        section.querySelectorAll(".underline-svg").forEach((svg) => {
          delete svg.dataset.animated;
          delete svg.dataset.observed;
          delete svg.dataset.animating;
        });
        section
          .querySelectorAll(".social-media__main-text[data-text-animation='true']")
          .forEach((el) => el.classList.remove("is-ready"));
        if (hasUnderlineWrappers()) init();
      }, 100);
    });
  }
  window.reinitUnderlineSystem = function () {
    if (!hasUnderlineWrappers()) return;
    observedElements.clear();
    document.querySelectorAll(".underline-svg").forEach((svg) => {
      delete svg.dataset.animated;
      delete svg.dataset.observed;
      delete svg.dataset.animating;
    });
    document
      .querySelectorAll(".social-media__main-text[data-text-animation='true']")
      .forEach((el) => el.classList.remove("is-ready"));
    if (globalObserver) {
      globalObserver.disconnect();
      globalObserver = null;
    }
    init();
  };
})();
